<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label [for]="idHtml">{{libelle$ | async }}</label>
    <div class="input-group">
        <div class="input-group-preprend" *ngIf="prefixe">
          <span class="input-group-text">{{prefixe}}</span>
        </div>
       <input [readOnly]="afficherEnLectureSeule" type="text"  [mask]="maskFormat" [separatorLimit]="separatorLimit"
       thousandSeparator=" " [decimalMarker]="decimalMarker"
       [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" 
       [formControlName]="label" [class]="'form-control ' + classeSupplInput" [id]="idHtml">
      </div>    
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors"></bis-affiche-erreurs>
  </div>
</form>

